<ph-search-select #picker
                  [items]="items"
                  [toggles]="toggles"
                  [value]="selectedKey"
                  [placeholder]="placeholder"
                  [disabled]="isDisabled"
                  [hasError]="hasError"
                  search-placeholder="Search accounts…"
                  empty-label="No matching accounts"
                  aria-label="Select bank account"
                  (ph-change)="onPick($event.detail)"
                  (ph-toggle)="onToggle($event.detail)"></ph-search-select>

<app-add-org-bank-account-dialog [open]="addBankAccountOpen" (closed)="onAddBankAccountClosed($event)"></app-add-org-bank-account-dialog>
